module.exports = __webpack_public_path__ + "static/media/upsell-benefit-manage.14320aa3.svg";